module.exports = __webpack_public_path__ + "img/app2.6738c612.png";